import React, { useState, useCallback } from "react";
import PortalPCResearchBar from "./PortalPCResearchBar";
import PortalPCDetailSearchModal from "./PortalPCDetailSearchModal";

function PortalPCDetailSearch() {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <>
      <PortalPCResearchBar isOpen={isOpen} onOpen={open} />
      {isOpen && <PortalPCDetailSearchModal onClose={close} />}
    </>
  );
}

export default PortalPCDetailSearch;
